import { CheckoutContent } from "components"
export const CheckoutPage = () => {
    return <CheckoutContent />
}